import React from 'react'
import { FeaturedEventsItemStyled } from '../Item.styles'
import { SvgLazy } from '@mobi/component-library/Common/Svg/SvgLazy'
import { AppRoutes } from '@core/AppRoutes'
import { useFeature } from '@core/Utils/hooks/useFeature'
import { FeatureItemAnalyticsData, trackFeatureItemClicked } from '../analytics'
import { Badge } from '@core/Areas/FollowMe/Components/Badge/Badge'
import { appHistory } from '@core/Utils/routing/history'
import styled from '@emotion/styled'

interface ExpertHubFeatureItemProps {
  accountNumber: number | null
}

export function ExpertHubFeaturedItemListElement({ accountNumber }: ExpertHubFeatureItemProps) {
  const isFollowMeFeatureActive = useFeature('content-hub-follow-me')

  if (!isFollowMeFeatureActive) {
    return null
  }

  const followMeRoute = AppRoutes.FollowMe

  const expertHubTileData: FeatureItemAnalyticsData = {
    featureItemTitle: 'ExpertHub Feature Tile',
    featureItemPosition: 0,
    accountNumber: accountNumber,
    internalTrackingCode: null,
    clickUrl: followMeRoute,
    endDate: '',
  }

  const navigateToFollowMe: React.MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault()
    trackFeatureItemClicked(expertHubTileData)
    appHistory.push(followMeRoute)
  }

  return (
    <FeaturedEventsItemStyled href='#' onClick={navigateToFollowMe}>
      <WrapperStyled>
        <Badge>NEW</Badge>
        <SvgLazy width='8rem' color='' name='ExpertHubLogo' />
      </WrapperStyled>
    </FeaturedEventsItemStyled>
  )
}

// =======
// Styles
// =======

const WrapperStyled = styled('span')({
  position: 'relative',

  span: {
    position: 'absolute',
    bottom: 32,
    left: 62,
  },
})
